const getters = {
	//   sidebar: state => state.app.sidebar,
	//   device: state => state.app.device,
	roles: state => state.user.roles,
	rolesStr: state => state.user.rolesStr,
	menuList: state => state.user.menuList,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js